/* FFS catch slideshow — Dry Flies hero (v20260706). Auto-advance with
   arrows/dots/keyboard. Pauses on hover/focus; honors reduced motion. */
(function () {
  var AUTO_MS = 4500;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.ffsCatchReady === 'true') return;
    root.dataset.ffsCatchReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.ffs-catch-show__slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.ffs-catch-show__dot'));
    var index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function play() {
      if (reducedMotion) return;
      stop();
      timer = setInterval(function () {
        show(index + 1);
      }, AUTO_MS);
    }

    var prev = root.querySelector('.ffs-catch-show__arrow--prev');
    var next = root.querySelector('.ffs-catch-show__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); play(); });
    if (next) next.addEventListener('click', function () { show(index + 1); play(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); play(); });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { show(index - 1); play(); }
      if (event.key === 'ArrowRight') { show(index + 1); play(); }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    play();
  }

  function initAll() {
    document.querySelectorAll('[data-ffs-catch-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  // Facet filtering swaps the product grid HTML (and the grid-slot copy of
  // the slideshow with it) — watch for that and re-init fresh copies.
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && typeof MutationObserver !== 'undefined') {
    new MutationObserver(initAll).observe(gridContainer, { childList: true, subtree: true });
  }
})();
